<template>
  <section class="project">
    <div class="back-white"></div>
    <div class="project-content">
      <h2 class="title">解决方案</h2>
      <div class="bar">
        <div class="circular"></div>
      </div>
      <p class="subheading">提供信息化设计、系统研发、系统集成、网络安全、物联网接入、物联网应用等企业信息化相关的综合服务</p>
      <div class="solution">
        <div class="solution-content">
          <div class="first">
            <div class="grid-content">
                <div class="icon">
                  <div class="back-image"></div>
                  <img src="@/assets/img/pic1.png"/>
                </div>
                <h3 class="subtitle">信息技术运维</h3>
                <p class="detailed">
                对IT运行环境（如基础环境、硬件和软件环境、网络环境等）、IT业务系统等提供综合服务。
                </p>
                <a @click="GoToSolution" class="link">
                  <v-icon class="flaticon-software" name="arrow-right" />
                </a>
            </div>
          </div>
        </div>
        <div class="solution-content">
          <div class="second">
             <div class="grid-content">
                <div class="icon">
                  <div class="back-image"></div>
                  <img src="@/assets/img/pic2.png"/>
                </div>
                <h3 class="subtitle">信息技术咨询</h3>
                <p class="detailed">
                  IT技术顾问服务，包括：IT战略规划及实施计划、IT系统设计、IT管理、IT工程监理等咨询服务。
                </p>
                <a @click="GoToSolution" class="link">
                  <v-icon class="flaticon-software" name="arrow-right"/>
                </a>
            </div>
          </div>
        </div>
        <div class="solution-content">
            <div class="grid-content third">
              <div class="icon">
                <div class="back-image"></div>
                <img src="@/assets/img/pic3.png"/>
              </div>
              <h3 class="subtitle">数据处理</h3>
                <p class="detailed">
                  数据（包括数值的和非数值的）分析、整理、计算、编辑、数据恢复等加工和处理。
                </p>
                <a @click="GoToSolution" class="link">
                  <v-icon class="flaticon-software" name="arrow-right"/>
                </a>
            </div>
          </div>
        </div>
      </div>
  </section>
</template>

<script>
export default {
  name: "project",
  methods: {
    /**
     * 箭头点击跳解决方案页面
     */
    GoToSolution () {
      this.$router.push({path: '/solution', query: { mark: 1 }})
    }
  }
}
</script>

<style lang="scss" scoped>
.project {
  position: relative;
  width: 100%;
  padding-top: 70px;
  padding-bottom: 70px;
  z-index: 1;
  background: linear-gradient(135deg, #23bdb8 0%, #43e794 100%);
}
.back-white {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 37%;
  width: 100%;
  background: #ffffff;
  z-index: -1;
}
.project-content {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  @media (max-width: 260px) {
    .grid-content {
      width: 219px;
      margin-bottom: 30px;
    }
    .third {
      margin-bottom: 0px;
    }
  }

  @media (min-width: 576px) {
    max-width: 540px;
  }

  @media (max-width: 767px) {
    .subheading {
      padding: 0 15px;
      text-align: left;
      text-indent: 25px;
    }
    .grid-content {
      margin-bottom: 30px;
    }
    .third {
      margin-bottom: 0px;
    }
    .solution {
      display: inline;
    }
    padding-right: 0px;
    padding-left: 0px;
  }

  @media (min-width: 768px) {
    max-width: 620px;
  }

  @media (min-width: 992px) {
    max-width: 860px;
  }

  @media (min-width: 1200px) {
    max-width: 1040px;
  }

  // ipad
  @media (width: 768px) and (height: 1024px) {
    .solution {
      .solution-content {
        &:last-child {
          display: none;
        }
      }
    }
  }
}

.title {
  color: #fff;
  font-size: 22px;
  margin: 0;
}

.bar {
  height: 4px;
  width: 90px;
  background: #ffe1fd;
  margin: 20px auto;
  position: relative;
  border-radius: 40px;

  .circular {
    position: absolute;
    left: 0;
    top: -3.2px;
    height: 10px;
    width: 10px;
    border-radius: 50%;
    background: #ffffff;
    animation: mymove 4s infinite;
    -webkit-animation: mymove 4s infinite; /*Safari and Chrome both*/
   
    @keyframes mymove {
      from {
        left: 0px;
      }

      to {
        left: 82px;
      }
    }
    
    @-webkit-keyframes mymove /*Safari and Chrome*/ {
      from {
        left: 0px;
      }

      to {
        left: 82px;
      }
    }
  }
}

.subheading {
  color: #fff;
  font-size: 14px;
  max-width: 520px;
  margin: 0 auto;
  margin-bottom: 50px;
  line-height: 1.9;
}

.solution {
  display: flex;
  &:last-child {
    margin-bottom: 0;
  }
}

.solution-content {
  position: relative;
  padding: 0 15px;
  flex: 1;
}

.grid-content {
  position: relative;
  padding: 30px;
  text-align: center;
  background-color: #ffffff;
  border: 1px dashed #cdf1d8;
  z-index: 1;
  -webkit-transition: 0.5s;
  transition: 0.5s;

  .subtitle {
    transition: 0.5s;
    margin-top: 22px;
    margin-bottom: 17px;
    line-height: 1.4;
    z-index: 999;
    font-size: 16px;
    font-weight: 500;
    color: #0e314c;
  }

  .detailed {
    margin-bottom: 25px;
    transition: 0.9s;
    font-size: 14px;
    color: #6084a4;
    line-height: 1.9;
    letter-spacing: 1px;
  }

  .link {
    display: block;
    width: 40px;
    height: 40px;
    line-height: 40px;
    margin: 0 auto;
    color: #0e314c;
    background-color: #eef0f3;
    border-radius: 50%;
    transition: 0.5s;

    .flaticon-software {
      width: 10px;
      height: 40px;
    }
  }

  &:hover {
    border: 1px dashed #e36cd9;

    .link {
      background-color: #e36cd9;

      .flaticon-software {
        cursor: pointer;
        color: #ffffff;
      }
    }
  }
}

.icon {
  display: inline-block;
  border: 1px solid #f3f8fd;
  width: 90px;
  height: 90px;
  line-height: 112px;
  border-radius: 50%;
  position: relative;
  z-index: 1;

  .back-image {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: -1;
    bottom: 0;
    background: #f7fafd;
    border-radius: 50%;
    margin: 6px;
    -webkit-transition: 0.5s;
    transition: 0.5s;
  }
  
  img {
    width: 40px;
  }
}
</style>